import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, Output, SecurityContext } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertPopup, HttpLoader, path } from 'app/app.config';
import { ChatService } from 'app/components/chat-list/chat.service';
import { jsPDF } from "jspdf";
import { AssistBotService } from '../../assist-bot.service';
import { DialogService } from 'app/services/dialog.service';
import { ListdialogComponent } from 'app/core/listdialog/listdialog.component';
import { saveAs as importedSaveAs } from "file-saver";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AiAssistComponent } from '../../ai-assist.component';
import { LlmService } from 'app/services/llm.service';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';

import Quill from "quill";

import ImageResize from 'quill-image-resize';
import { ActivatedRoute } from '@angular/router';
Quill.register("modules/resize", ImageResize);


declare const $: any;

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss']
})
export class BotComponent {
  profileUrl = path.PROFILE_URL;
  volumeicons: any = ["pi pi-volume-off", "pi pi-volume-up"];
  @Input() data;
  @Input() userDetail;
  @Input() index;
  @Input() speakeLanguage;
  @Output() copyText: EventEmitter<any> = new EventEmitter();
  @Output() PingChat: EventEmitter<any> = new EventEmitter();
  @Output() Like: EventEmitter<any> = new EventEmitter();
  @Output() Dislike: EventEmitter<any> = new EventEmitter();
  showPaginateSpinner: boolean = false;
  showSpinner: boolean = false;

  multipleAnswers: boolean = false;
  multipleAnswersData: any[] = [];

  showModal = false;
  editAIData: any;
  editBotHistoryId: any;
  editingAnswerIndex: number = -1; // Track which answer item is being edited when multipleAnswers is true

  public isActiveFeedback: boolean = false;
  public isInActiveFeedback: boolean = false;
  // Track feedback state per answerItem index
  public answerItemFeedbackState: { [key: number]: { active: boolean, inactive: boolean } } = {};

  synth = window.speechSynthesis;
  showTextView: boolean = false;
  commentForm: FormGroup = new FormGroup({});
  showuserIcon: boolean = false;

  // base_url:any = `http://115.246.210.90:8502`;
  llm_url: any;
  doc_uuid: any;
  safeHtml: SafeHtml;
  documentFileName: any;
  documentFileNameError: any;
  source_doc: any;
  editorFullView: boolean = false;
  is_generic: boolean = false;
  usercomments: any;
  editor_modules: any;
  quill: any;
  isPin: boolean = false;
  isSpeak: string = 'off';
  document_id: any;
  cleanedSourceParagraphs: SafeHtml = '';

  documentSearch: boolean = false;
  mode: any;
  searchView: boolean = false;
  constructor(private fb: FormBuilder, @Inject(DOCUMENT) private document: Document, private alert: AlertPopup, private http: HttpClient, private chatService: ChatService, private assistBotService: AssistBotService, private dialogService: DialogService, private httpLoader: HttpLoader, private sanitizer: DomSanitizer, private aiassistsComp: AiAssistComponent, private llmService: LlmService, private route: ActivatedRoute, private confirmDialogService: ConfirmationDialogService) {

  }

  ngOnInit() {
    // Always try to restore from localStorage first to ensure we have the latest data
    this.llmService.restoreLLMBotPayload();

    this.cleanSourceParagraphs();

    // Get document_id - it might be an array or a single value
    this.document_id = this.llmService.llm_bot_payload['document_id'];


    // if(this.document_id && this.document_id.length==0){
    //   this.alert.showAlertMessage({"message":"Please select document"});
    //   return;
    // }
    this.mode = this.llmService.llm_bot_payload['mode'];

    if (this.llmService.llm_bot_payload['model_type'] === 1) {
      this.documentSearch = true;
    } else {
      this.documentSearch = false;
    }

    if (!this.assistBotService.queryType?.library) {
      this.is_generic = true;

    } else {
      this.is_generic = false;

    }

    this.commentForm = this.fb.group({
      'comment': new FormControl('', Validators.required)
    });

    if (this.data.bot_answer) {
      this.showPaginateSpinner = false;
    }


    let headers: any = new Headers();
    headers.append('Content-Type', 'application/json');

    if (this.data?.search && this.data?.bot_type !== "suggestion") {

      this.showPaginateSpinner = true;
      let question_query = this.data.question.toLowerCase().trim();


      let payload: any;
      let user_id = window.localStorage.getItem('user_id');

      console.log(this.data, 'data');

      console.log(this.data.question.trim(), 'question');
      console.log(this.data.questionArray, 'questionArray from data');
      console.log('Is questionArray an array?', Array.isArray(this.data.questionArray));
      // Use questionArray from data if available and is an array (each item is a full sentence, not split)
      // Otherwise, fallback to splitting by comma for backward compatibility
      const questionArray = (Array.isArray(this.data.questionArray) && this.data.questionArray.length > 0)
        ? this.data.questionArray
        : this.data.question.split(',').map(q => q.trim()).filter(q => q.length > 0);

      console.log('Final questionArray (each item is a full sentence):', questionArray);
      console.log('Is final questionArray an array?', Array.isArray(questionArray));
      console.log('questionArray length:', questionArray.length);

      if (this.is_generic) {
        payload = {
          "query": this.data.question.trim()
        }

        this.llmService.llmGenericQuery(payload).subscribe({
          next: (response: any) => {
            console.log("llmGenericQuery response:", response);

            this.showPaginateSpinner = false;
            // this.htmltagsplit(response['answer_html']);
            this.data['bot_answer'] = response['formatted_response'];
            this.data['query_type'] = "generic";
            let botPayload = {
              "user_id": user_id,
              "question": questionArray,
              "answer": response['formatted_response'],
              "question_type": "history",
              "bot_type": "bot",
              "source_doc": "",
              "sequence_id": new Date().valueOf(),
              "query_type": "generic"
            };
            this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
              if (result['success']) {
                this.data["question_type"] = "history";
                this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                this.data["history_id"] = result['createdMessage']["history_id"];
                this.data["createdAt"] = new Date();
                this.data["search"] = false;
                // this.aiassistsComp.chatbotData.unshift(this.data);
                // this.assistBotService.chatHistoryList.unshift(this.data);
                this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
              }

            }, (error: HttpErrorResponse) => {
              this.showPaginateSpinner = false;
            });
          },
          error: (response: HttpErrorResponse) => {
            this.showPaginateSpinner = false;
          }
        });
      } else {

        if (this.documentSearch) {
          payload = {
            "document_id": this.document_id.toString(),
            "question": questionArray,
            "mode": this.mode
          }

          this.llmService.llmsearchAndQAUploadSearch(payload).subscribe({
            next: (res: any) => {
              console.log("llmsearchAndQAUploadSearch response:", res);
              this.showPaginateSpinner = false;
              this.multipleAnswers = true;
              // Ensure multipleAnswersData is always an array
              this.multipleAnswersData = Array.isArray(res) ? res : [res];
              this.data['query_type'] = "private";

              // Check if res is an array
              const responses = Array.isArray(res) ? res : [res];

              // Combine all answers from multiple responses
              let combinedAnswer = '';
              let allSourceParagraphs = [];
              let allDocumentIds = [];
              let allSourceDocs = [];

              responses.forEach((response, index) => {
                if (this.mode == 'answer') {
                  const answer = this.changeNewLine(response['answer']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += answer;
                } else {
                  const searchAnswer = this.getSearch(response['source_paragraphs']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += searchAnswer;
                }

                // Collect all source paragraphs
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  allSourceParagraphs = allSourceParagraphs.concat(response['source_paragraphs']);
                }

                // Collect all document IDs
                if (response['queried_document_ids'] && Array.isArray(response['queried_document_ids'])) {
                  allDocumentIds = allDocumentIds.concat(response['queried_document_ids']);
                }

                // Collect source documents for deduplication
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  response['source_paragraphs'].forEach((para: any) => {
                    if (para.document_name && allSourceDocs.indexOf(para.document_name) === -1) {
                      allSourceDocs.push(para.document_name);
                    }
                  });
                }
                let botPayload = {
                  "user_id": user_id,
                  "question": questionArray,
                  "answer": response['answer'],
                  "question_type": "history",
                  "bot_type": "bot",
                  "source_doc": response['source_doc'],
                  "sequence_id": new Date().valueOf(),
                  // "group_ids": this.document_id,
                  "query_type": "private",
                  "document_ids": response['queried_document_ids'],
                  "source_paragraphs": response['source_paragraphs']
                };
                this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
                  if (result['success']) {
                    this.data["question_type"] = "history";
                    this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                    this.data["history_id"] = result['createdMessage']["history_id"];
                    // this.data["group_ids"] = this.document_id;
                    this.data["createdAt"] = new Date();
                    this.data["search"] = false;
                    // this.aiassistsComp.chatbotData.unshift(this.data);
                    //this.assistBotService.chatHistoryList.unshift(this.data);
                    this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
                  }


                }, (error: HttpErrorResponse) => {
                  this.showPaginateSpinner = false;
                });
              });

              // Set combined data
              this.data['bot_answer'] = combinedAnswer
              this.data['source_doc'] = allSourceDocs.join(', ');
              this.data['text'] = this.fileSources_para_text(allSourceParagraphs);



            },
            error: (error: HttpErrorResponse) => {
              this.showPaginateSpinner = false;
            }
          });

        } else if (this.llmService.llm_bot_payload['model_type'] === 1) {
          payload = {
            "query": questionArray,
            "bypass_cache": true,
            "client_id": localStorage.getItem('company_id'),
            "doc_id": this.document_id,
          }
          this.llmService.llmSimpleQuery_v2(payload).subscribe({
            next: (response: any) => {
              console.log("llmSimpleQuery_v2 response:", response);
              this.showPaginateSpinner = false;
              this.showPaginateSpinner = false;
              this.data['bot_answer'] = this.changeNewLine(response['response']);
              this.data['source_doc'] = this.fileSources(response["sources"]);
              this.data['query_type'] = "private";
              let botPayload = {
                "user_id": user_id,
                "question": questionArray,
                "answer": response['response'],
                "question_type": "history",
                "bot_type": "bot",
                "source_doc": this.data['source_doc'],
                "sequence_id": new Date().valueOf(),
                // "group_ids": this.assistBotService.seletedClass,
                "query_type": "private",
                "document_ids": response['queried_document_ids'],
                "source_paragraphs": response['source_paragraphs']
              };
              this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
                if (result['success']) {
                  this.data["question_type"] = "history";
                  this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                  this.data["history_id"] = result['createdMessage']["history_id"];
                  // this.data["group_ids"] = this.document_id;
                  this.data["createdAt"] = new Date();
                  this.data["search"] = false;
                  // this.aiassistsComp.chatbotData.unshift(this.data);
                  //this.assistBotService.chatHistoryList.unshift(this.data);
                  this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
                }

              }, (error: HttpErrorResponse) => {
                this.showPaginateSpinner = false;
              });
            },
            error: (error: HttpErrorResponse) => {
              this.showPaginateSpinner = false;
            }
          });
        } else if (this.llmService.llm_bot_payload['model_type'] === 2) {
          payload = {
            "query": questionArray,
            "bypass_cache": true,
            "client_id": localStorage.getItem('company_id'),
            "doc_id": this.document_id,
          }

          this.llmService.llmQuery_v2(payload).subscribe({
            next: (res: any) => {
              //   console.log("llmQuery_v2 response:", response);
              this.showPaginateSpinner = false;
              this.showPaginateSpinner = false;
              //   this.data['bot_answer'] = this.changeNewLine(response['response']);
              //   this.data['source_doc'] = this.fileSources(response["sources"]);
              //   this.data['query_type'] = "private";
              //   let botPayload = {
              //     "user_id": user_id,
              //     "question": questionArray,
              //     "answer": response['response'],
              //     "question_type": "history",
              //     "bot_type": "bot",
              //     "source_doc": this.data['source_doc'],
              //     "sequence_id": new Date().valueOf(),
              //     "query_type": "private",
              //     "document_ids": response['queried_document_ids'],
              //     "source_paragraphs": response['source_paragraphs']

              //   };
              //   this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
              //     if (result['success']) {
              //       this.data["question_type"] = "history";
              //       this.data["sequence_id"] = result['createdMessage']["sequence_id"];
              //       this.data["history_id"] = result['createdMessage']["history_id"];
              //       this.data["group_ids"] = this.document_id;
              //       this.data["createdAt"] = new Date();
              //       this.data["search"] = false;
              //       this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
              //     }

              //   }, (error: HttpErrorResponse) => {
              //     this.showPaginateSpinner = false;
              //   });
              // },
              this.multipleAnswers = true;
              // Ensure multipleAnswersData is always an array
              this.multipleAnswersData = Array.isArray(res) ? res : [res];
              this.data['query_type'] = "private";

              // Check if res is an array
              const responses = Array.isArray(res) ? res : [res];

              // Combine all answers from multiple responses
              let combinedAnswer = '';
              let allSourceParagraphs = [];
              let allDocumentIds = [];
              let allSourceDocs = [];

              responses.forEach((response, index) => {
                if (this.mode == 'answer') {
                  const answer = this.changeNewLine(response['answer']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += answer;
                } else {
                  const searchAnswer = this.getSearch(response['source_paragraphs']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += searchAnswer;
                }

                // Collect all source paragraphs
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  allSourceParagraphs = allSourceParagraphs.concat(response['source_paragraphs']);
                }

                // Collect all document IDs
                if (response['queried_document_ids'] && Array.isArray(response['queried_document_ids'])) {
                  allDocumentIds = allDocumentIds.concat(response['queried_document_ids']);
                }

                // Collect source documents for deduplication
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  response['source_paragraphs'].forEach((para: any) => {
                    if (para.document_name && allSourceDocs.indexOf(para.document_name) === -1) {
                      allSourceDocs.push(para.document_name);
                    }
                  });
                }
                let botPayload = {
                  "user_id": user_id,
                  "question": questionArray,
                  "answer": response['answer'],
                  "question_type": "history",
                  "bot_type": "bot",
                  "source_doc": response['source_doc'],
                  "sequence_id": new Date().valueOf(),
                  // "group_ids": this.document_id,
                  "query_type": "private",
                  "document_ids": response['queried_document_ids'],
                  "source_paragraphs": response['source_paragraphs']
                };
                this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
                  if (result['success']) {
                    this.data["question_type"] = "history";
                    this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                    this.data["history_id"] = result['createdMessage']["history_id"];
                    // this.data["group_ids"] = this.document_id;
                    this.data["createdAt"] = new Date();
                    this.data["search"] = false;
                    // this.aiassistsComp.chatbotData.unshift(this.data);
                    //this.assistBotService.chatHistoryList.unshift(this.data);
                    this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
                  }


                }, (error: HttpErrorResponse) => {
                  this.showPaginateSpinner = false;
                });
              });

              // Set combined data
              this.data['bot_answer'] = combinedAnswer
              this.data['source_doc'] = allSourceDocs.join(', ');
              this.data['text'] = this.fileSources_para_text(allSourceParagraphs);



            },
            error: (error: HttpErrorResponse) => {
              this.showPaginateSpinner = false;
            }
          });


        } else if(this.llmService.llm_bot_payload['model_type']===3){
          payload = {
            "document_id": this.document_id.toString(),
            "question": questionArray,
            "mode": this.mode
          }

          this.llmService.llmsearchContractSearch(payload).subscribe({
            next: (res: any) => {
              console.log("llmsearchContractSearch response:", res);
              this.showPaginateSpinner = false;
              this.multipleAnswers = true;
              // Ensure multipleAnswersData is always an array
              this.multipleAnswersData = Array.isArray(res) ? res : [res];
              this.data['query_type'] = "private";

              // Check if res is an array
              const responses = Array.isArray(res) ? res : [res];

              // Combine all answers from multiple responses
              let combinedAnswer = '';
              let allSourceParagraphs = [];
              let allDocumentIds = [];
              let allSourceDocs = [];

              responses.forEach((response, index) => {
                if (this.mode == 'answer') {
                  const answer = this.changeNewLine(response['answer']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += answer;
                } else {
                  const searchAnswer = this.getSearch(response['source_paragraphs']);
                  if (index > 0) {
                    combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
                  }
                  combinedAnswer += searchAnswer;
                }

                // Collect all source paragraphs
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  allSourceParagraphs = allSourceParagraphs.concat(response['source_paragraphs']);
                }

                // Collect all document IDs
                if (response['queried_document_ids'] && Array.isArray(response['queried_document_ids'])) {
                  allDocumentIds = allDocumentIds.concat(response['queried_document_ids']);
                }

                // Collect source documents for deduplication
                if (response['source_paragraphs'] && Array.isArray(response['source_paragraphs'])) {
                  response['source_paragraphs'].forEach((para: any) => {
                    if (para.document_name && allSourceDocs.indexOf(para.document_name) === -1) {
                      allSourceDocs.push(para.document_name);
                    }
                  });
                }
                let botPayload = {
                  "user_id": user_id,
                  "question": questionArray,
                  "answer": response['answer'],
                  "question_type": "history",
                  "bot_type": "bot",
                  "source_doc": response['source_doc'],
                  "sequence_id": new Date().valueOf(),
                  // "group_ids": this.document_id,
                  "query_type": "private",
                  "document_ids": response['queried_document_ids'],
                  "source_paragraphs": response['source_paragraphs']
                };
                this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
                  if (result['success']) {
                    this.data["question_type"] = "history";
                    this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                    this.data["history_id"] = result['createdMessage']["history_id"];
                    // this.data["group_ids"] = this.document_id;
                    this.data["createdAt"] = new Date();
                    this.data["search"] = false;
                    // this.aiassistsComp.chatbotData.unshift(this.data);
                    //this.assistBotService.chatHistoryList.unshift(this.data);
                    this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
                  }


                }, (error: HttpErrorResponse) => {
                  this.showPaginateSpinner = false;
                });
              });

              // Set combined data
              this.data['bot_answer'] = combinedAnswer
              this.data['source_doc'] = allSourceDocs.join(', ');
              this.data['text'] = this.fileSources_para_text(allSourceParagraphs);



            },
            error: (error: HttpErrorResponse) => {
              this.showPaginateSpinner = false;
            }
          });
        }

        /*  if (this.assistBotService.seletedClass.length == 0) {
            payload = {
              "query": this.data.question.trim().substring(0, this.data.question.length - 9),
              "bypass_cache": true,
              "client_id": Number(localStorage.getItem('company_id')),
              //"class_id":this.llmService.LLM_classes
            }
          } else {

            if(this.documentSearch){
              payload = {
                "document_id":this.document_id,
                "query": this.data.question.trim().substring(0, this.data.question.length - 9),
                "mode":"search"
              }

              this.llmService.llmsearchAndQAUploadSearch(payload).subscribe({
                next:(response:any)=>{
                   this.showPaginateSpinner = false;
                    this.data['bot_answer'] = response['answer'];
                     let botPayload = {
                "user_id": user_id,
                "question": this.data.question.trim(),
                "answer": response['answer'],
                "question_type": "history",
                "bot_type": "bot",
                "source_doc": this.data["source_paragraphs"][0]['document'],
                "sequence_id": new Date().valueOf(),
                "group_ids": this.assistBotService.seletedClass,
                "query_type": "private"
              };
              this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
                if (result['success']) {
                  this.data["question_type"] = "history";
                  this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                  this.data["history_id"] = result['createdMessage']["history_id"];
                  this.data["group_ids"] = this.document_id;
                  this.data["createdAt"] = new Date();
                  this.data["search"] = false;
                  // this.aiassistsComp.chatbotData.unshift(this.data);
                  //this.assistBotService.chatHistoryList.unshift(this.data);
                  this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
                }

              }, (error: HttpErrorResponse) => {
                this.showPaginateSpinner = false;
              });
                },
                error:(error:HttpErrorResponse)=>{}
              })

            }else{

               payload = {
                  "query": this.data.question.trim().substring(0, this.data.question.length - 9),
                  "bypass_cache": true,
                  "client_id": localStorage.getItem('company_id'),
                  "class_id": this.assistBotService.seletedClass,
               }

            }


          } */


        /* this.llmService.llmQuery(payload).subscribe({
           next: (response: any) => {
             this.showPaginateSpinner = false;
             this.data['bot_answer'] = response['response'];

             if (response.hasOwnProperty("source_documents")) {
               if (response['source_documents'].length > 0) {
                 this.source_doc = response['source_documents'];
                 this.data["source_doc"] = this.getSourcedoc_names(this.source_doc);
                 // this.doc_uuid = response['result']['document_sources'][0]['doc_uuid'];
               }
             }

             let botPayload = {
               "user_id": user_id,
               "question": this.data.question.trim(),
               "answer": response['response'],
               "question_type": "history",
               "bot_type": "bot",
               "source_doc": this.data["source_doc"],
               "sequence_id": new Date().valueOf(),
               "group_ids": this.assistBotService.seletedClass,
               "query_type": "private"
             };
             this.assistBotService.createHistory(botPayload).subscribe((result: any) => {
               if (result['success']) {
                 this.data["question_type"] = "history";
                 this.data["sequence_id"] = result['createdMessage']["sequence_id"];
                 this.data["history_id"] = result['createdMessage']["history_id"];
                 this.data["group_ids"] = result['createdMessage']["group_ids"];
                 this.data["createdAt"] = new Date();
                 this.data["search"] = false;
                 // this.aiassistsComp.chatbotData.unshift(this.data);
                 //this.assistBotService.chatHistoryList.unshift(this.data);
                 this.assistBotService.historyListBheaviour.next({ "templateName": "bot" });
               }

             }, (error: HttpErrorResponse) => {
               this.showPaginateSpinner = false;
             });
           },
           error: (error: HttpErrorResponse) => {
             this.showPaginateSpinner = false;
              //this.alert.showAlertMessage({ "message":error['error'] });
           }
         }); */



      }



    }


    /*  if(this.data?.bot_type=="suggestion" && this.data?.search){

      this.data["search"] = false;


      let user_id = window.localStorage.getItem('user_id');
      let botPayload ={
      "user_id":user_id,
      "question":this.data['question'],
      "answer":this.data['bot_answer'],
      "question_type":"history",
      "bot_type":"suggestion",
      "sequence_id":new Date().valueOf()
      };

      this.assistBotService.createHistory(botPayload).subscribe((result:any)=>{
         if(result['success']){
         this.data["question_type"]="history";
          this.data["sequence_id"]=result['createdMessage']["sequence_id"];
          this.data["history_id"] = result['createdMessage']["history_id"];
          this.data["created_at"] = new Date();
          this.data["search"] = false;
          this.assistBotService.chatHistoryList.unshift(this.data);
          this.assistBotService.historyListBheaviour.next({"templateName":"suggestion"});
        }

      });

     } */



  }

  //   speakText(state:boolean,textdata:string){

  //     let voices = this.synth.getVoices();

  //     let speakLanguage:any, defaultVoice:any;

  //     if(this.speakeLanguage === 'hindi'){
  //       speakLanguage = 'Google हिन्दी';
  //       defaultVoice = 'Microsoft Kalpana - Hindi (India)';
  //     }else if(this.speakeLanguage === 'spanish'){
  //       speakLanguage = 'Google español';
  //       defaultVoice = 'Microsoft Helena - Spanish (Spain)';
  //     }else{
  //       speakLanguage = 'Google UK English Female';
  //       defaultVoice = 'Microsoft Heera - English (India)';
  //     }

  //      let botVoice = voices.findIndex(
  //       (items) => {
  //         items.name === speakLanguage
  //       }
  //     );
  //     let botDefaultVoice = voices.findIndex(
  //       (items) => {
  //         items.name === defaultVoice}
  //     );


  //     let text = textdata.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g," ").replace(/[\/\\#,+()$~.'":*?<>{}]/gi,'');
  //     if ('speechSynthesis' in window) {
  //        var utterThis = new SpeechSynthesisUtterance(text);

  //        utterThis.voice =
  //       botVoice > -1 ? voices[botVoice] : voices[botDefaultVoice];
  //        if(state){
  //         speechSynthesis.cancel();
  //         if (this.speakeLanguage === 'hindi') {
  //           utterThis.lang = 'hi-IN'
  //         }else if(this.speakeLanguage === 'spanish'){
  //           utterThis.lang = 'es-ES'
  //         }else{
  //           utterThis.lang = 'en-US'
  //         }
  //         // utterThis.lang = this.speakeLanguage === 'hindi' ? 'hi-IN' : this.speakeLanguage;
  //         // console.log(utterThis, 'speach');

  //         window.speechSynthesis.speak(utterThis);
  //        }else{
  //         speechSynthesis.cancel();
  //        }

  //      } else {
  //          console.log('not support ');
  //      }




  //    let interval =  setInterval(()=>{
  //        if(!this.synth.speaking){
  //          clearInterval(interval);
  //           Array.from(document.querySelectorAll('.toggle-icon.is-active')).forEach(function(el) {
  //               el.classList.remove('is-active');
  //           });
  //        }
  //       },1000);

  // }

  get questionText() {
    try {
      const parsed = JSON.parse(this.data?.question);

      console.log(parsed,);


      return parsed.question;
    } catch {
      return this.data?.question;
    }
  }

  speakText(state: boolean, textdata: string) {
    if (!('speechSynthesis' in window)) {
      console.log('Speech synthesis not supported in this browser.');
      return;
    }

    // Make sure synth is initialized
    if (!this.synth) {
      this.synth = window.speechSynthesis;
    }

    let voices = this.synth.getVoices();

    // Log available voices once (optional, for debugging)
    if (voices.length === 0) {
      console.warn("No voices found. Voices may load asynchronously.");
    }

    let speakLanguage: string;
    let defaultVoice: string;

    if (this.speakeLanguage === 'hindi') {
      speakLanguage = 'Google हिन्दी';
      defaultVoice = 'Microsoft Kalpana - Hindi (India)';
    } else if (this.speakeLanguage === 'spanish') {
      speakLanguage = 'Google español';
      defaultVoice = 'Microsoft Helena - Spanish (Spain)';
    } else {
      speakLanguage = 'Google US English';
      defaultVoice = 'Microsoft Zira - English (United States)';
    }

    let botVoice = voices.findIndex((v) => v.name === speakLanguage);
    let botDefaultVoice = voices.findIndex((v) => v.name === defaultVoice);

    // Clean text (remove HTML tags & &nbsp;)
    let text = textdata.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");

    // Create utterance
    const utterThis = new SpeechSynthesisUtterance(text);
    utterThis.rate = 0.9; // Slightly faster than 0.5 for better pacing

    // Select voice
    utterThis.voice = botVoice > -1
      ? voices[botVoice]
      : botDefaultVoice > -1
        ? voices[botDefaultVoice]
        : voices[0]; // fallback to first available voice

    // Set language
    if (this.speakeLanguage === 'hindi') {
      utterThis.lang = 'hi-IN';
    } else if (this.speakeLanguage === 'spanish') {
      utterThis.lang = 'es-ES';
    } else {
      utterThis.lang = 'en-US';
    }

    if (state) {
      this.synth.cancel(); // stop any previous speech
      this.synth.speak(utterThis);
    } else {
      this.synth.cancel();
    }

    // Clean up toggle icon after speech ends
    const interval = setInterval(() => {
      if (!this.synth.speaking) {
        clearInterval(interval);
        document.querySelectorAll('.toggle-icon.is-active')
          .forEach((el) => el.classList.remove('is-active'));
      }
    }, 500);
  }

  showFeedbackform(index?: number) {
    if (index !== undefined) {
      // For multiple answers - track per item
      if (!this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index] = { active: false, inactive: false };
      }
      this.answerItemFeedbackState[index].active = true;
      this.answerItemFeedbackState[index].inactive = false;
    } else {
      // For single answer - use global state
      this.isActiveFeedback = true;
      this.isInActiveFeedback = false;
    }
    console.log(this.isActiveFeedback, 'isActive');
  }

  showInActiveFeedback(index?: number) {
    if (index !== undefined) {
      // For multiple answers - track per item
      if (!this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index] = { active: false, inactive: false };
      }
      this.answerItemFeedbackState[index].inactive = true;
      this.answerItemFeedbackState[index].active = false;
    } else {
      // For single answer - use global state
      this.isInActiveFeedback = true;
      this.isActiveFeedback = false;
    }
  }

  isAnswerItemActiveFeedback(index: number): boolean {
    return this.answerItemFeedbackState[index]?.active || false;
  }

  isAnswerItemInActiveFeedback(index: number): boolean {
    return this.answerItemFeedbackState[index]?.inactive || false;
  }

  submitForm() {
    this.alert.showAlertMessage({ "message": "Thanks for your feedback." });
    $('#inputField').focus();
  }

  copiedText(index: any) {
    this.copyText.emit(index);
  }

  PingedChat(index: any) {
    this.PingChat.emit(index);
    this.isPin = true;
  }

  Liked(index: any) {
    this.Like.emit(index);
  }

  Disliked(index: any) {
    this.Dislike.emit(index);
  }

  saveComment(items: any, accurate, index?: number) {
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirm Submission',
      message: 'Are you sure you want to submit this feedback?',
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (confirmed: boolean) => {
        if (confirmed) {
          this.submitFeedback(items, accurate, index);
        }
      }
    });
  }

  submitFeedback(items: any, accurate, index?: number) {
    console.log(items);

    this.showSpinner = true;

    const refId = new Date().valueOf();
    let user_id = localStorage.getItem("user_id");
    let comment_payload = {
      "history_id": items.history_id,
      "type": "comments",
      "comments": this.commentForm.value['comment'],
      "sequence_id": refId,
      "user_id": user_id,
      "question": items.question ? items.question.join(", ") : "",
      "answer": items.bot_answer ? items.bot_answer : "",
      "query_type": items.query_type ? items.query_type : "",
      "accurate": accurate ? accurate : "",
      "source_doc": items.source_doc ? [items.source_doc] : "",

    }

    this.assistBotService.createComments(comment_payload).subscribe({
      next: (result: any) => {
        this.alert.showAlertMessage({ 'message': 'Your comments saved' });
        this.showSpinner = false;
        if (index !== undefined) {
          // For multiple answers - reset per item
          if (this.answerItemFeedbackState[index]) {
            this.answerItemFeedbackState[index].active = false;
            this.answerItemFeedbackState[index].inactive = false;
          }
        } else {
          // For single answer - use global state
          this.isActiveFeedback = false;
          this.isInActiveFeedback = false;
        }
        this.commentForm.reset();
      },
      error: (error: any) => {
        this.showSpinner = false;
        console.error('Error saving feedback:', error);
        this.alert.showAlertMessage({
          'message': error.error?.message || error.message || 'Failed to save feedback. Please try again.'
        });
      }
    });

    // const payLoad = {"group_id":345,"message":message,"unique_ref_id":refId};
    // this.chatService.sendGroupMessage(payLoad).subscribe(
    //     (messageRes) => {
    //       if (messageRes['createdMessage']) {
    //         this.alert.showAlertMessage({'message':'Your comments saved'});
    //       }
    //     });
    //   Array.from(document.querySelectorAll('.comment-area-box')).map((el)=> {
    //     el.classList.remove('is-active');
    //  });

  }

  cancelComment(data?: any, index?: number) {
    if (index !== undefined) {
      // For multiple answers - reset per item
      if (this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index].active = false;
        this.answerItemFeedbackState[index].inactive = false;
      }
    } else {
      // For single answer - use global state
      this.isActiveFeedback = false;
      this.isInActiveFeedback = false;
    }
    this.commentForm.reset();
  }

  prepareCommentData(answerItem: any) {
    // Prepare question as array
    let questionArray = [];
    if (Array.isArray(answerItem.question)) {
      questionArray = answerItem.question;
    } else if (answerItem.question) {
      questionArray = [answerItem.question];
    }

    // Prepare document_ids from source_paragraphs
    let documentIds = '';
    if (answerItem.source_paragraphs && Array.isArray(answerItem.source_paragraphs)) {
      documentIds = answerItem.source_paragraphs
        .map((p: any) => p.document_id)
        .filter((id: any) => id)
        .join(',');
    }

    return {
      history_id: this.data.history_id,
      question: questionArray,
      bot_answer: answerItem.answer || '',
      query_type: this.data.query_type || '',
      document_ids: documentIds
    };
  }


  onKeypressEvent(event: any) {
    let comment = event.target.value;

    if ((event.code == "Enter") || (event.code == "NumpadEnter")) {
    }
  }
  downloadPDF(items: any) {

    var doc = new jsPDF();
    var img = new Image()
    img.src = '../assets/images/absence_gpt.png';
    doc.addImage(img, 'png', 0, 0, 100, 25);
    doc.setFont("sans-serif");
    doc.setTextColor('#000');
    doc.setFontSize(14);
    doc.text("Question:" + items.question, 15, 30);
    doc.setTextColor('#000');
    doc.setFontSize(11);

    items.bot_answer = items.bot_answer.replace(/<br\s*[\/]?>/gi, "\n");
    var splitTitle = doc.splitTextToSize(items.bot_answer, 185);
    doc.text(splitTitle, 15, 38);


    var userId = window.localStorage.getItem('user_id');

    doc.save(userId + '_' + 'assign' + new Date().getTime() + '.pdf');
    var blob = doc.output('blob');
    this.alert.showAlertMessage({ 'message': 'Answer downloaded' });
    console.log(blob);
  }

  changeNewLine(bot) {
    // if (bot?.hasOwnProperty("bot_answer")) {
    //   return bot['bot_answer']?.replaceAll(/\n/g, '<br>').replaceAll(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");
    // } else {
    //   return bot?.replaceAll(/\n/g, '<br>').replaceAll(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");
    // }
    return bot
  }

  ngAfterViewInit() {

    if (this.assistBotService.ChatCommentsList.length > 0) {
      let comments_filter = this.assistBotService.ChatCommentsList.filter((list: any) => list.history_id == this.data.history_id);

    }
    if (this.assistBotService.chatPinList.length > 0) {

      let pingfilter = this.assistBotService.chatPinList.filter((ping: any) => ping['sequence_id'] == this.data["sequence_id"]);
      if (pingfilter.length > 0) {
        this.isPin = true;
      }
    }

  }

  openEditAIModal(botData: any, answerIndex?: number) {
    this.editAIData = this.changeNewLine(botData["bot_answer"]);
    this.editBotHistoryId = botData.history_id;
    this.editingAnswerIndex = answerIndex !== undefined ? answerIndex : -1;
    this.showModal = true;

    // setTimeout(()=>{
    let content = document.getElementById("editor_" + this.data.history_id);
    let toolbarOptions = [
      ["bold",
        "italic",
        "underline",
        "strike",
        "image",
        "link"],
      [{ 'color': [] }, { 'background': [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ 'font': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
      [{ 'align': [] }],
      ['clean']
    ];
    this.quill = new Quill(content, {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions,
        resize: {
          locale: {
            center: "center",
          },
        },
      },
    });


    // this.documentFileNameError="";

    this.quill.clipboard.dangerouslyPasteHTML(this.editAIData);
    //  },1500);


  }

  closeModal() {
    if (this.document.getElementsByClassName("ql-toolbar").length > 0) {
      this.document.getElementsByClassName("ql-toolbar")[0].remove();
    }
    this.showModal = false;
    this.quill = null;
    this.editingAnswerIndex = -1; // Reset the editing index when closing
  }

  saveEditAI(historyId, botData: any) {
    // Update the item logic here, possibly emitting event or calling a service
    // console.log('Saved:', this.editAIData);

    // const payload = {
    //     bot_answer: this.editAIData
    // }

    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }

    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {

      console.log( 'updateAIBotHistory',response);


      if (this.multipleAnswers && this.editingAnswerIndex >= 0 && this.multipleAnswersData[this.editingAnswerIndex]) {
        this.multipleAnswersData[this.editingAnswerIndex].answer = response['data']['bot_answer'];

        // Also update the combined bot_answer in this.data
        let combinedAnswer = '';
        this.multipleAnswersData.forEach((item, index) => {
          if (this.mode == 'answer') {
            const answer = this.changeNewLine(item.answer);
            if (index > 0) {
              combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
            }
            combinedAnswer += answer;
          } else {
            const searchAnswer = this.getSearch(item.source_paragraphs);
            if (index > 0) {
              combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
            }
            combinedAnswer += searchAnswer;
          }
        });
        this.data['bot_answer'] = combinedAnswer;
      } else {

        this.data = response['data'];
      }

      console.log(this.data, 'data');
      this.closeModal();
      this.httpLoader.hideLoader();
      this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      this.editingAnswerIndex = -1; // Reset the editing index
    });
    // this.closeModal();
  }

  refresh() {
    this.data['createdAt'] = new Date();
    let user_id = window.localStorage.getItem('user_id');
    this.showPaginateSpinner = true;
    // if(this.data.bot_answer){
    //  this.showPaginateSpinner = false;
    // }

    let headers: any = new Headers();
    headers.append('Content-Type', 'application/json');

    if (this.data?.bot_type !== "suggestion") {

      this.showPaginateSpinner = true;
      let question_query = this.data.question.trim().toLowerCase();
      let payload: any = "";
      // this.llm_url = this.assistBotService.GptConfiguration['LLm_url'];
      // let content_image=  this.filterImages(this.data.bot_answer);
      if (this.data['query_type'] == "generic") {
        this.is_generic = true;
        // let url_library = this.llm_url+"generic_query";
        // this.llm_url = url_library;
        // }
      } else {
        this.is_generic = false;
        // let url_library = this.llm_url+"query";
        // this.llm_url = url_library;
      }
      const questionArray = this.data.question
        .split(',');

      if (this.is_generic) {
        payload = {
          "query": this.data.question.trim()
        }
        this.llmService.llmGenericQuery(payload).subscribe({
          next: (response: any) => {
            console.log("llmGenericQuery response:", response);
            this.showPaginateSpinner = false;
            this.data['bot_answer'] = response['formatted_response'];
            this.data['query_type'] = "generic";
            let botPayload = {
              "user_id": user_id,
              "question": questionArray,
              "answer": response['formatted_response'],
              "question_type": "history",
              "bot_type": "bot",
              "source_doc": "",
              "sequence_id": new Date().valueOf(),
              "query_type": "generic"
            };

            let params = {
              history_id: this.data.history_id,
              user_id: user_id
            }
            this.assistBotService.RefreshBotData(botPayload, params).subscribe((result: any) => {

              if (result['success']) {
                this.data["question_type"] = "history";
                this.data["createdAt"] = new Date();
                this.data["search"] = false;
                this.alert.showAlertMessage({ "message": "Your requested data refreshed successfully." });

              }

            });

          },
          error: (response: HttpErrorResponse) => {
            this.showPaginateSpinner = false;
          }
        });
      } else {
        if (this.data.group_ids.length > 0) {
          payload = {
            "query": questionArray,
            "bypass_cache": true,
            "client_id": localStorage.getItem('company_id'),
            "class_id": this.data.group_ids
          }
        } else {
          payload = {
            "query": questionArray,
            "bypass_cache": true,
            "client_id": localStorage.getItem('company_id')
          }
        }



        this.llmService.llmQuery(payload).subscribe({
          next: (response: any) => {
            console.log("llmQuery response:", response);
            this.showPaginateSpinner = false;
            this.data['bot_answer'] = response['response'];
            if (response.hasOwnProperty("source_documents")) {
              if (response['source_documents'].length > 0) {
                this.source_doc = response['source_documents'];
                this.data["source_doc"] = this.getSourcedoc_names(this.source_doc);
                // this.doc_uuid = response['result']['document_sources'][0]['doc_uuid'];
              }
            }
            let botPayload = {
              "user_id": user_id,
              "question": questionArray,
              "answer": response['response'],
              "question_type": "history",
              "bot_type": "bot",
              "source_doc": this.data["source_doc"],
              "sequence_id": new Date().valueOf(),
            };

            let params = {
              history_id: this.data.history_id,
              user_id: user_id
            }
            this.assistBotService.RefreshBotData(botPayload, params).subscribe((result: any) => {

              if (result['success']) {
                this.data["question_type"] = "history";
                this.data["createdAt"] = new Date();
                this.data["search"] = false;
                this.alert.showAlertMessage({ "message": "Your requested data refreshed successfully." });

              }

            });

          },
          error: (response: HttpErrorResponse) => {
            this.showPaginateSpinner = false;
          }
        });
      }


      /* this.http.post( this.llm_url, payload, {headers: headers}).subscribe((response:any)=>{

           this.showPaginateSpinner= false;

            if(this.is_generic){
               this.data['bot_answer']=response['formatted_response'];
              }else{
                  this.data['bot_answer']=response['result']['answer'];
            }
            if(response.hasOwnProperty("result")){
              if(response['result'].hasOwnProperty("document_sources")){

                          if(response['result']['document_sources'].length > 0){
                              this.source_doc = response['result']['document_sources'];
                              this.data["source_doc"]=this.getSourcedoc_names(this.source_doc);
                                this.doc_uuid = response['result']['document_sources'][0]['doc_uuid'];
                              }
                      } else{
                        this.source_doc=[];
                      }
            }

           let user_id = window.localStorage.getItem('user_id');
           let botPayload:any;

               if(this.is_generic){
                  botPayload = {
                            "question":this.data.question.trim(),
                                    "bot_answer":response['formatted_response'],
                                    "question_type":"history",
                                    "bot_type":"bot",
                                    "source_doc":"",
                                    "sequence_id":this.data.sequence_id
                                  };
              }else{
                 botPayload ={
                      "question":this.data.question.trim(),
                      "bot_answer": response['result']['answer'],
                      "question_type":"history",
                      "bot_type":"bot",
                      "source_doc":this.getSourcedoc_names(this.source_doc),
                      "sequence_id":this.data.sequence_id
                   }
              }


           let params={
            history_id:this.data.history_id,
            user_id:user_id
           }
          this.assistBotService.RefreshBotData(botPayload,params).subscribe((result:any)=>{

             if(result['success']){
               this.data["question_type"]="history";
               this.data["created_at"] = new Date();
               this.data["search"] = false;
               this.alert.showAlertMessage({"message":"Your requested data refreshed successfully."});
              //  this.assistBotService.chatHistoryList.unshift(this.data);
              //  this.assistBotService.historyListBheaviour.next({"templateName":"bot"});
             }

           });

         },(error:HttpErrorResponse)=>{
          this.alert.showAlertMessage({"message":error.error['error']});
           this.showPaginateSpinner= false;
         });
      */

    }


    // if(this.data?.bot_type=="suggestion" && this.data?.search){

    //  this.data["search"] = false;


    //  let user_id = window.localStorage.getItem('user_id');
    //  let botPayload ={
    //  "user_id":user_id,
    //  "question":this.data['question'],
    //  "answer":this.data['bot_answer'],
    //  "question_type":"history",
    //  "bot_type":"suggestion",
    //  "sequence_id":new Date().valueOf()
    //  };
    //  this.assistBotService.createHistory(botPayload).subscribe((result:any)=>{
    //     if(result['success']){
    //     this.data["question_type"]="history";
    //      this.data["sequence_id"]=result['createdMessage']["sequence_id"];
    //      this.data["history_id"] = result['createdMessage']["history_id"];
    //      this.data["created_at"] = new Date();
    //      this.data["search"] = false;
    //      this.assistBotService.chatHistoryList.unshift(this.data);
    //      this.assistBotService.historyListBheaviour.next({"templateName":"suggestion"});
    //    }

    //  });

    // }





  }

  cleanSourceParagraphs() {
    if (this.data.source_paragraphs) {
      // const cleaned = this.data.source_paragraphs
      //   .replace(/[^a-zA-Z0-9\s.,;:!?'"()\-]/g, '') // removes special chars
      //   .replace(/\s+/g, ' ') // normalize spaces
      //   .trim();

      let text = "";
      let duplicate_check: any = [];
      if (this.data.source_paragraphs.length > 0) {

        const cleaned = JSON.parse(this.data.source_paragraphs);
        cleaned.forEach((element: any) => {
          if (duplicate_check.indexOf(element['text']) == -1) {
            text = text + " " + element['text'] + "<span style='color: #1d72b2;'>( Source: " + element['document_name'] + ")</span>" + ",";
            duplicate_check.push(element['text']);
          }

        });
      }

      this.cleanedSourceParagraphs = this.safedata(text.substring(0, text.length - 1))
    }


  }

  openDialog() {

    this.dialogService.openListDialog(ListdialogComponent, {
      title: 'Save Document',
      btnOkText: 'Create',
      data: [
        { "label": "Save as a word document", "value": "word", "active": false },
        { "label": "Save as a pdf file ", "value": "pdf", "active": true }],
      onclose: (selectedList) => {
        if (selectedList) {

          let user_id = window.localStorage.getItem('user_id');
          let payload = {
            "user_id": parseInt(user_id),
            "question": this.data.question,
            "answer": this.data.bot_answer.replaceAll(/\*/g, "").replaceAll(/\#/g, ""),
            "question_type": selectedList['value'],
            "bot_type": this.data['bot_type'],
            "document_ids": this.data.document_ids,
            "query_type": this.data.query_type,
            "source_paragraphs": this.data.source_paragraphs,
            "sequence_id": new Date().valueOf()
          }

          this.assistBotService.BotFilegenerate(payload).subscribe((res: any) => {

            if (res['success']) {
              this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
              // this.aiassistsComp.chatfileList.unshift(res['result']);
              this.assistBotService.chatHistoryList.unshift(res['result']);
              this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
            } else {
              this.alert.showAlertMessage(res);
              this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
            }
          }, (error: any) => {

            // this.alert.showAlertMessage(error['error']);

          });
        }

      }
    });

  }

  generateAudio() {
    let user_id = window.localStorage.getItem('user_id');
    this.dialogService.openListDialog(ListdialogComponent, {
      title: 'Create Audio',
      btnOkText: 'Create',
      data: [
        { "label": "English", "value": "English" },
        { "label": "Tamil ", "value": "Tamil" },
        { "label": "Hindi ", "value": "Hindi" },
        { "label": "Spanish ", "value": "Spanish" },
        { "label": "German", "value": "German" },
        { "label": "Malayalam", "value": "Malayalam" },
        { "label": "kannada", "value": "Kannada" },
        { "label": "French", "value": "French" },
        { "label": "Danish", "value": "Danish" }],

      onclose: (selectedList) => {

        let payload = {
          "user_id": parseInt(user_id),
          "question": this.data.question,
          "answer": this.data.bot_answer.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, " ").replace(/[\/\\#,+()$~.'":*?<>{}]/gi, ''),
          "question_type": "audio",
          "bot_type": this.data['bot_type'],
          "sequence_id": new Date().valueOf(),
          "language": selectedList['value']
        }


        this.assistBotService.BotFilegenerate(payload).subscribe((res: any) => {
          if (res['success']) {
            this.alert.showAlertMessage({ 'message': 'Your requested data audio file was generated successfully.' });
            //this.aiassistsComp.chatfileAudioList.unshift(res['result']);
            this.assistBotService.chatHistoryList.unshift(res['result']);
            this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
          } else {
            this.alert.showAlertMessage({ 'message': 'Audio File already exists', 'type': 2 });
            this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
          }
        }, (error: any) => {
          console.log("file generate error", error);
          // this.alert.showAlertMessage(error['error']);
        });
      }
    });
    /*  */
  }

  // callSummarization(data:any){
  //   let payload = {
  //     "text":data,
  //     "task":"summarization"
  //     };
  //   return this.http.post("https://document.canstringai.com:8443/ca-llm/multiple_task",payload);
  // }



  viewSourceDoc(docId) {
    this.assistBotService.getllmfile(docId).subscribe((res_blob: any) => {
      let d = new Date();
      var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
        d.getHours() + "-" + d.getMinutes();
      this.alert.showAlertMessage({ 'message': 'Source document download', 'type': 2 });
      importedSaveAs(res_blob, datestring + ".pdf");
    });
  }

  safedata(data: string) {
    return this.sanitizer.bypassSecurityTrustHtml(data);
  }


  saveAsPdf(historyId, botData: any) {
    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined) {
      this.documentFileNameError = "Enter valid file name";
      return;
    }
    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }
    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {
      console.log("edit", response);
      this.data = response['data'];
      this.documentFileNameError = "";
      this.closeModal();
      this.httpLoader.hideLoader();
      // this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      let user_id = window.localStorage.getItem('user_id');
      let Filepayload = {
        "user_id": parseInt(user_id),
        "question": this.data.question,
        "answer": response['data']['bot_answer'],
        "question_type": "pdf",
        "bot_type": this.data['bot_type'],
        "document_file_name": this.documentFileName,
        "sequence_id": new Date().valueOf()
      }

      this.assistBotService.BotFilegenerate(Filepayload).subscribe((res: any) => {

        if (res['success']) {
          this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
          // this.aiassistsComp.chatfileList.unshift(res['result']);
          this.assistBotService.chatHistoryList.unshift(res['result']);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        } else {
          this.alert.showAlertMessage(res);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        }
      }, (error: any) => {

        // this.alert.showAlertMessage(error['error']);
        this.alert.showAlertMessage({ 'message': 'Your requested data file already exists.', 'type': 2 });
        this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
      });
    });

  }


  saveAsDoc(historyId, botData: any) {
    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined) {
      this.documentFileNameError = "Enter valid file name";
      return;
    }
    // const payload = {
    //       bot_answer: this.editAIData
    //   }
    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }
    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {
      console.log("edit", response);
      this.data = response['data'];
      this.closeModal();
      this.httpLoader.hideLoader();
      // this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      let user_id = window.localStorage.getItem('user_id');
      let Filepayload = {
        "user_id": parseInt(user_id),
        "question": this.data.question,
        "answer": response['data']['bot_answer'],
        "question_type": "word",
        "bot_type": this.data['bot_type'],
        "document_file_name": this.documentFileName,
        "sequence_id": new Date().valueOf()
      }

      this.assistBotService.BotFilegenerate(Filepayload).subscribe((res: any) => {

        if (res['success']) {
          this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
          // this.aiassistsComp.chatfileList.unshift(res['result']);
          // this.assistBotService.chatHistoryList.unshift(res['result']);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        } else {
          this.alert.showAlertMessage(res);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        }
      }, (error: any) => {

        // this.alert.showAlertMessage(error['error']);
        this.alert.showAlertMessage({ 'message': 'Your requested data file already exists.', 'type': 2 });
        this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
      });
    });
  }




  filterImages(str: any) {
    const imgRegExp = /(?:<img\s+src="(.*?)"[^.]*?\/?>|&lt;img\s+src="(.*?)"[^.]*?\/?&gt;)/gm;
    const images = [];
    let img;
    while ((img = imgRegExp.exec(str))) {
      images.push(img[1]);
    }
    return images;
  }

  htmltagsplit(data: any) {
    const htmlString = "The <span>quick</span> brown <b>fox</b> jumps.";
    //const parts = data.split(/(?=<[^>]+>)|(?<=<\/[^>]+>)/);
    const regex = /\s*(?<!\S)([^\s<>]+(?:\s+[^\s<>]+)*)(?!\S)\s*/;
    const parts = data.split(regex).filter(Boolean)
    console.log(parts);
    return parts;
  }



  ValidatefileName(event: any) {

    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined || this.documentFileName == "") {
      this.documentFileNameError = "Enter valid file name";
    } else {
      this.documentFileNameError = "";
    }
  }

  showSource(question: any) {
    if (question.indexOf("Private") != -1 && this.data.source_doc) {
      return true
    }
  }

  getSourcedoc_names(document_list: any) {
    let files_name = [];
    if (document_list.length > 0) {
      document_list.forEach((doc_key: any) => {
        if (doc_key["filename"]) {
          if (files_name.indexOf(doc_key["filename"]) == -1) {
            files_name.push(doc_key["filename"]);
          }
        }
      });

      return files_name.join(", ");
    }
  }

  modalFullScreen() {
    this.editorFullView = !this.editorFullView;
  }

  animateQuestion(Question: any) {
    return [Question];
  }

  formatQuestion(question: any): string {
    if (Array.isArray(question)) {
      return question.join(', ');
    }
    return question || '';
  }

  getSearch(source_paragraphs: any) {
    let answer: any = '';
    this.searchView = true;
    if (source_paragraphs?.length > 0) {
      source_paragraphs.forEach(element => {
        answer = answer + " " + element['text'] + "<br><br>";
      });
    }

    return answer;
  }

  fileSources(source_doc: any) {
    let source_docment: any = '';
    if (source_doc.length > 0) {
      source_doc.forEach((element: any) => {
        source_docment = source_docment + " " + element['filename'] + ",";
      });
    }
    return source_docment.substring(0, source_docment.length - 1);
  }

  fileSources_para(source_paragraphs: any) {
    let source_docment: any = '';
    let duplicate_check: any = [];
    if (source_paragraphs?.length > 0) {
      source_paragraphs.forEach((element: any) => {
        if (duplicate_check.indexOf(element['document_name']) == -1) {
          source_docment = source_docment + " " + element['document_name'] + ",";
          duplicate_check.push(element['document_name']);
        }

      });
    }
    return source_docment.substring(0, source_docment.length - 1);
  }
  fileSources_para_text(source_paragraphs: any) {
    console.log(source_paragraphs);

    let text: any = '';
    let duplicate_check: any = [];
    if (source_paragraphs.length > 0) {
      source_paragraphs.forEach((element: any) => {
        if (duplicate_check.indexOf(element['text']) == -1) {
          text = text + " " + element['text'] + "<span style='color: #1d72b2;'>( Source: " + element['document_name'] + ")</span>" + ",";
          duplicate_check.push(element['text']);
        }

      });
    } else {
      text = source_paragraphs;
    }
    return this.safedata(text.substring(0, text.length - 1));
  }
  toggleTextView() {
    this.showTextView = !this.showTextView;
  }
}
